<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 w-full">
				<p class="textGrey textLg textCenter">
					Routing Selection for <span>{{ zone.zone_name }}</span>
				</p>
			</div>
		</div>

		<div class="row margin-b50">
			<div class="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 w-full">
				<div class="card formPanel">
					<div class="content">
						<div class="col-md-12 margin-b40 flex w-full justify-center">
							<div class="formGroup flex flex-col">
								<label for="routingSelection" class="textGrey">Carrier Routing</label>
							</div>
							<div class="formGroup flex flex-col items-center md:flex-row">
								<input
									id="routingSelection"
									v-model="isAppRouting"
									type="checkbox"
									class="tw-toggle ml-4 border-none bg-transparent"
								/>
							</div>
							<div class="formGroup flex flex-col">
								<label for="routingSelection" class="textGrey">App Routing</label>
							</div>
						</div>

						<div v-if="isAppRouting">
							<application-config v-model="appData" :tenants="tenants" :show-all-apps="true" />
						</div>
						<div v-else>
							<div v-if="modifiedCarrierZones?.length" class="margin-b30 col-md-12 flex flex-wrap gap-2">
								<div class="formGroup withIcon w-full lg:max-w-[350px]">
									<select v-model="copyFrom" class="min-w-full">
										<option :value="null">-- Select Zone to Copy --</option>
										<option v-for="z in modifiedCarrierZones" :key="z.zone_name" :value="z">
											{{ z.zone_name }}
										</option>
									</select>
									<span class="fa-light fa-chevron-down"></span>
								</div>
								<button
									:disabled="!copyFrom"
									class="jmiBtn green w-full md:mt-0 md:w-auto"
									@click="copyCarrierOrder(copyFrom)"
								>
									Copy Rule
								</button>
							</div>
							<p class="textCenter margin-b20">
								<span class="textGrey mr-1">Current default order is: </span
								><span>{{ defaultOrder }}</span>
							</p>
							<div class="margin-b30">
								<div class="col-md-12">
									<div class="formGroup withIcon">
										<label class="textGrey">Default Carrier #1</label>
										<select v-model="carrier1">
											<option :value="null">-- Unassigned --</option>
											<option v-for="c in carriers" :key="c.id" :value="c">{{ c.name }}</option>
										</select>
										<span class="fa-light fa-chevron-down"></span>
									</div>
								</div>
							</div>
							<div v-if="carrier1" class="margin-b30">
								<div class="col-md-12">
									<div class="formGroup withIcon">
										<label class="textGrey">Default Carrier #2</label>
										<select v-model="carrier2">
											<option :value="null">-- Unassigned --</option>
											<option v-for="c in carriers" :key="c.id" :value="c">{{ c.name }}</option>
										</select>
										<span class="fa-light fa-chevron-down"></span>
									</div>
								</div>
							</div>
							<div v-if="carrier2" class="margin-b30">
								<div class="col-md-12">
									<div class="formGroup withIcon">
										<label class="textGrey">Default Carrier #3</label>
										<select v-model="carrier3">
											<option :value="null">-- Unassigned --</option>
											<option v-for="c in carriers" :key="c.id" :value="c">{{ c.name }}</option>
										</select>
										<span class="fa-light fa-chevron-down"></span>
									</div>
								</div>
							</div>
							<div v-if="carrier3" class="margin-b30">
								<div class="col-md-12">
									<div class="formGroup withIcon">
										<label class="textGrey">Default Carrier #4</label>
										<select v-model="carrier4">
											<option :value="null">-- Unassigned --</option>
											<option v-for="c in carriers" :key="c.id" :value="c">{{ c.name }}</option>
										</select>
										<span class="fa-light fa-chevron-down"></span>
									</div>
								</div>
							</div>
							<div v-if="carrier4" class="margin-b30">
								<div class="col-md-12">
									<div class="formGroup withIcon">
										<label class="textGrey">Default Carrier #5</label>
										<select v-model="carrier5">
											<option :value="null">-- Unassigned --</option>
											<option v-for="c in carriers" :key="c.id" :value="c">{{ c.name }}</option>
										</select>
										<span class="fa-light fa-chevron-down"></span>
									</div>
								</div>
							</div>
							<div v-if="carrier5" class="margin-b30">
								<div class="col-md-12">
									<div class="formGroup withIcon">
										<label class="textGrey">Default Carrier #6</label>
										<select v-model="carrier6">
											<option :value="null">-- Unassigned --</option>
											<option v-for="c in carriers" :key="c.id" :value="c">{{ c.name }}</option>
										</select>
										<span class="fa-light fa-chevron-down"></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg green" @click="save()">Confirm</a></li>
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['user', 'userRoles', 'tenants'],
	props: ['zone', 'carriers', 'lcr', 'modifiedCarrierZones'],
	data() {
		return {
			carrier1: null,
			carrier2: null,
			carrier3: null,
			carrier4: null,
			carrier5: null,
			carrier6: null,
			isAppRouting: false,
			copyFrom: null,
			appData: {
				tenant: this.lcr?.tenant || null,
				app: null,
				appConfig: {
					call_forwarding: {
						destination: '',
						cli_preference: 'AS_RECEIVED'
					},
					sip_trunk: {
						trunkId: null
					},
					mobile_sim: {
						simId: null
					},
					prompt_then_forward: {
						destination: '',
						cli_preference: 'AS_RECEIVED'
					}
				}
			}
		}
	},
	computed: {
		defaultOrder() {
			return this.lcr.default_carrier_1
				? `${this.lcr.default_carrier_1.name}${
						this.lcr.default_carrier_2 ? ', ' + this.lcr.default_carrier_2.name : ''
					}${this.lcr.default_carrier_3 ? ', ' + this.lcr.default_carrier_3.name : ''}${
						this.lcr.default_carrier_4 ? ', ' + this.lcr.default_carrier_4.name : ''
					}${this.lcr.default_carrier_5 ? ', ' + this.lcr.default_carrier_5.name : ''}${
						this.lcr.default_carrier_6 ? ', ' + this.lcr.default_carrier_6.name : ''
					}`
				: 'None set.'
		}
	},
	created() {
		if (this.zone?.send_to_app?.selectedApp) {
			this.isAppRouting = true
			this.appData.app = this.zone?.send_to_app?.selectedApp + ''
			this.appData.tenant = this.lcr?.tenant || null
			this.appData.account = this.zone?.send_to_app?.account || null
			this.appData.appConfig = JSON.parse(JSON.stringify(this.zone.send_to_app.app_config || {}))
		} else if (this.zone?.carrier_selection) {
			if (this.zone.carrier_selection.carrier1)
				this.carrier1 = this.carriers.find((c) => c.id === this.zone.carrier_selection.carrier1)
			if (this.zone.carrier_selection.carrier2)
				this.carrier2 = this.carriers.find((c) => c.id === this.zone.carrier_selection.carrier2)
			if (this.zone.carrier_selection.carrier3)
				this.carrier3 = this.carriers.find((c) => c.id === this.zone.carrier_selection.carrier3)
			if (this.zone.carrier_selection.carrier4)
				this.carrier4 = this.carriers.find((c) => c.id === this.zone.carrier_selection.carrier4)
			if (this.zone.carrier_selection.carrier5)
				this.carrier5 = this.carriers.find((c) => c.id === this.zone.carrier_selection.carrier5)
			if (this.zone.carrier_selection.carrier6)
				this.carrier6 = this.carriers.find((c) => c.id === this.zone.carrier_selection.carrier6)
		}
	},
	mounted() {
		document.addEventListener('keyup', this.onKeyUp)
	},
	beforeUnmount() {
		document.removeEventListener('keyup', this.onKeyUp)
	},
	methods: {
		save() {
			if (this.isAppRouting) {
				this.$emit('save', {
					selectedApp: this.appData.app,
					app_config: this.appData.appConfig,
					tenant: this.appData.tenant,
					account: this.appData.account,
					zone_name: this.zone.zone_name
				})
			} else {
				this.$emit('save', {
					carrier1: this.carrier1,
					carrier2: this.carrier2,
					carrier3: this.carrier3,
					carrier4: this.carrier4,
					carrier5: this.carrier5,
					carrier6: this.carrier6,
					zone_name: this.zone.zone_name
				})
			}
		},
		copyCarrierOrder(copyFrom) {
			this.carrier1 = this.carriers.find((c) => c.id === copyFrom.carrier_selection.carrier1) || null
			this.carrier2 = this.carriers.find((c) => c.id === copyFrom.carrier_selection.carrier2) || null
			this.carrier3 = this.carriers.find((c) => c.id === copyFrom.carrier_selection.carrier3) || null
			this.carrier4 = this.carriers.find((c) => c.id === copyFrom.carrier_selection.carrier4) || null
			this.carrier5 = this.carriers.find((c) => c.id === copyFrom.carrier_selection.carrier5) || null
			this.carrier6 = this.carriers.find((c) => c.id === copyFrom.carrier_selection.carrier6) || null
		},
		close() {
			this.$emit('close')
		},
		onKeyUp(event) {
			if (event.key == 'Escape') this.$emit('close')
		}
	}
}
</script>
